import { requestGet } from "@/utils/dva16";
import { EGet, NTab, RSetState } from "./contants";

export default {
	namespace: NTab,
	state: {
		tabList: null,
		load: false,
	},
	reducers: {
		[RSetState](state, { payload }) {
			return {
				...state,
				...payload,
			};
		},
	},
	effects: {
		async [EGet]({ payload, callback }, { call, reducer, select, effect }) {
			reducer(RSetState, { load: true });
			let res = await requestGet("tab", payload);
			reducer(RSetState, { tabList: res, load: false });
		},
	},
};
